<template>
  <div class="admin-panel">
    <div class="loader" v-if="loading"><div class="spinner"></div></div>

    <table class="admin-table">
      <thead><tr><th>Имя файла</th><th>Создан</th><th>ID</th><th></th></tr></thead>
      <tbody>
        <tr v-for="f in items" :key="f.id">
          <td>{{ f.name }}</td>
          <td>{{ formatDate(f.createdAt) }}</td>
          <td class="mono">{{ f.id }}</td>
          <td><button class="danger" @click="remove(f)">Удалить</button></td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <button :disabled="cursorStack.length === 0" @click="prevPage">&larr; Назад</button>
      <button :disabled="!hasMore" @click="nextPage">Вперёд &rarr;</button>
    </div>
  </div>
</template>

<script>
import { adminApi } from '../api/admin-api';
import Vue from 'vue';

export default {
  name: 'file-list',
  data() {
    return {
      items: [],
      loading: false,
      after: null,
      cursorStack: [],
      hasMore: false,
      lastId: null,
    };
  },
  methods: {
    formatDate(iso) {
      if (!iso) return '—';
      return new Date(iso).toLocaleString('ru-RU');
    },
    async load(after) {
      this.loading = true;
      try {
        const { data } = await adminApi.get('/files', { params: { after: after || undefined, limit: 20 } });
        this.items = data.data;
        this.hasMore = data.hasMore;
        this.lastId = data.lastId;
      } finally {
        this.loading = false;
      }
    },
    nextPage() {
      this.cursorStack.push(this.after);
      this.after = this.lastId;
      this.load(this.after);
    },
    prevPage() {
      this.after = this.cursorStack.pop();
      this.load(this.after);
    },
    async remove(f) {
      if (!confirm(`Удалить файл "${f.name || f.id}"? Это действие нельзя отменить.`)) return;
      await adminApi.delete(`/files/${f.id}`);
      Vue.toasted.show('Файл удалён', { type: 'success', duration: 2000 });
      await this.load(this.after);
    },
  },
  mounted() {
    this.load(null);
  }
};
</script>

<style scoped>
.admin-panel {
  position: relative;
  padding: 10px;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.admin-table th, .admin-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #e0e0e0;
}

.mono {
  font-family: monospace;
  font-size: 12px;
}

.pagination {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}

button {
  cursor: pointer;
}

button.danger {
  background: #fff;
  color: #d94a36;
  border: 1px solid #d94a36;
  border-radius: 5px;
  padding: 4px 10px;
}

.loader {
  position: absolute;
  top: 10px;
  right: 10px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0,0,0,0.1);
  border-left-color: #e74c3c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/file-list.vue